// This is Application form or Profile form of Attorney with 5 Steps.
<template>
  <div class="space-y-2 text-gray-900 antialiased bg-white">
    <!-- Panel with multiple steps -->
    <div class="lg:border-t lg:border-b lg:border-gray-200">
      <nav class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" aria-label="Progress">
        <ol
          class="rounded-md overflow-hidden lg:flex lg:border-l lg:border-r lg:border-gray-200 lg:rounded-none"
        >
          <li class="step-wizard relative overflow-hidden lg:flex-1">
            <div class="border border-gray-200 overflow-hidden border-b-0 rounded-t-md lg:border-0">
              <!-- Completed Step -->
              <a href="#" class="group">
                <span
                  class="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                  aria-hidden="true"
                ></span>
                <span class="px-6 py-5 flex items-start text-sm font-medium">
                  <span class="flex-shrink-0">
                    <span
                      class="w-10 h-10 flex items-center justify-center border-2 cobalt-border-color rounded-full"
                    >
                      <span class="text-indigo-600">01</span>
                    </span>
                  </span>
                  <span class="mt-0.5 ml-4 min-w-0 flex flex-col">
                    <span class="text-xs font-semibold uppercase tracking-wide">Primary Details</span>
                    <span class="text-sm font-medium text-gray-500">Contact, Address</span>
                  </span>
                </span>
              </a>
            </div>
          </li>
          <li class="step-wizard relative overflow-hidden lg:flex-1">
            <div class="border border-gray-200 overflow-hidden border-t-0 rounded-b-md lg:border-0">
              <!-- Upcoming Step -->
              <a href="#" class="group">
                <span
                  class="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                  aria-hidden="true"
                ></span>
                <span class="px-6 py-5 flex items-start text-sm font-medium lg:pl-9">
                  <span class="flex-shrink-0">
                    <span
                      class="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full"
                    >
                      <span class="text-gray-400">02</span>
                    </span>
                  </span>
                  <span class="mt-0.5 ml-4 min-w-0 flex flex-col">
                    <span class="text-xs font-semibold uppercase tracking-wide">Practice Details</span>
                    <span class="text-sm font-medium text-gray-500">Practice & License Details</span>
                  </span>
                </span>
              </a>

              <div class="hidden absolute top-0 left-0 w-3 inset-0 lg:block" aria-hidden="true">
                <svg
                  class="h-full w-full text-gray-300"
                  viewBox="0 0 12 82"
                  fill="none"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M0.5 0V31L10.5 41L0.5 51V82"
                    stroke="currentcolor"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </div>
            </div>
          </li>
          <li class="step-wizard relative overflow-hidden lg:flex-1">
            <div class="border border-gray-200 overflow-hidden border-t-0 rounded-b-md lg:border-0">
              <!-- Upcoming Step -->
              <a href="#" class="group">
                <span
                  class="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                  aria-hidden="true"
                ></span>
                <span class="px-6 py-5 flex items-start text-sm font-medium lg:pl-9">
                  <span class="flex-shrink-0">
                    <span
                      class="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full"
                    >
                      <span class="text-gray-400">03</span>
                    </span>
                  </span>
                  <span class="mt-0.5 ml-4 min-w-0 flex flex-col">
                    <span class="text-xs font-semibold uppercase tracking-wide">Coverages</span>
                    <span class="text-sm font-medium text-gray-500">Practice Areas</span>
                  </span>
                </span>
              </a>

              <div class="hidden absolute top-0 left-0 w-3 inset-0 lg:block" aria-hidden="true">
                <svg
                  class="h-full w-full text-gray-300"
                  viewBox="0 0 12 82"
                  fill="none"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M0.5 0V31L10.5 41L0.5 51V82"
                    stroke="currentcolor"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </div>
            </div>
          </li>
          <li class="step-wizard relative overflow-hidden lg:flex-1">
            <div class="border border-gray-200 overflow-hidden border-t-0 rounded-b-md lg:border-0">
              <!-- Upcoming Step -->
              <a href="#" class="group">
                <span
                  class="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                  aria-hidden="true"
                ></span>
                <span class="px-6 py-5 flex items-start text-sm font-medium lg:pl-9">
                  <span class="flex-shrink-0">
                    <span
                      class="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full"
                    >
                      <span class="text-gray-400">04</span>
                    </span>
                  </span>
                  <span class="mt-0.5 ml-4 min-w-0 flex flex-col">
                    <span
                      class="text-xs font-semibold text-gray-500 uppercase tracking-wide"
                    >Disclosures & Billing Information</span>
                    <span class="text-sm font-medium text-gray-500"></span>
                  </span>
                </span>
              </a>
              <div class="hidden absolute top-0 left-0 w-3 inset-0 lg:block" aria-hidden="true">
                <svg
                  class="h-full w-full text-gray-300"
                  viewBox="0 0 12 82"
                  fill="none"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M0.5 0V31L10.5 41L0.5 51V82"
                    stroke="currentcolor"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </div>
            </div>
          </li>
          <li class="step-wizard relative overflow-hidden lg:flex-1">
            <div class="border border-gray-200 overflow-hidden border-t-0 rounded-b-md lg:border-0">
              <!-- Upcoming Step -->
              <a href="#" class="group">
                <span
                  class="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                  aria-hidden="true"
                ></span>
                <span class="px-6 py-5 flex items-start text-sm font-medium lg:pl-9">
                  <span class="flex-shrink-0">
                    <span
                      class="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full"
                    >
                      <span class="text-gray-400">05</span>
                    </span>
                  </span>
                  <span class="mt-0.5 ml-4 min-w-0 flex flex-col">
                    <span
                      class="text-xs font-semibold text-gray-500 uppercase tracking-wide"
                    >PREVIEW & COMPLETE</span>
                    <span class="text-sm font-medium text-gray-500"></span>
                  </span>
                </span>
              </a>
              <div class="hidden absolute top-0 left-0 w-3 inset-0 lg:block" aria-hidden="true">
                <svg
                  class="h-full w-full text-gray-300"
                  viewBox="0 0 12 82"
                  fill="none"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M0.5 0V31L10.5 41L0.5 51V82"
                    stroke="currentcolor"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </div>
            </div>
          </li>
        </ol>
      </nav>
    </div>
    <div class="tab-wizard">
      <!-- Importing Primary detail Component -->
      <app-primary ref="child_comp_0" v-if="isShow" :forms="form"></app-primary>
    </div>
    <div class="tab-wizard">
      <!-- Importing Practice detail Component -->
      <app-practice ref="child_comp_1" v-if="isShow" :forms="form"></app-practice>
    </div>
    <div class="tab-wizard">
      <!-- Importing Coverage detail Component -->
      <app-coverages ref="child_comp_2" v-if="isShow" :forms="form"></app-coverages>
    </div>
    <div class="tab-wizard">
      <!-- Importing Billing or Payment detail Component -->
      <app-disclosure ref="child_comp_3" v-if="isShow" :forms="form"></app-disclosure>
    </div>
    <div class="tab-wizard">
      <!-- Importing Preview or Confirm Component -->
      <app-preview ref="child_comp_4" v-if="isShow" :forms="form"></app-preview>
    </div>
    <div class="grid md:grid-cols-8 grid-cols-3 justify-items-stretch py-6 px-6 gap-4">
      <!-- Buttons to go Prev and Next Step -->
      <button
        type="button"
        id="save_temp"
        @click="openSaveExitModal(true)"
        class="md:col-span-6 col-span-3 md:w-auto w-full justify-self-start inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-200"
      >Save and Exit</button>
      <button
        type="button"
        id="download_app_pdf"
        @click="downloadAppPdf()"
        class="md:col-span-5 col-span-3 md:w-auto w-full justify-self-start inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-200"
      >Download Application (PDF)</button>
      <button
        type="button"
        id="prevBtn"
        @click="nextPrev(-1)"
        class="md:col-span-1 col-span-3 items-center px-6 py-3 border border-transparent shadow-sm text-base font-medium rounded-md text-white cobalt-button-color hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >Previous</button>
      <button
        type="button"
        id="nextBtn"
        @click="nextPrev(1)"
        class="md:col-span-1 col-span-3 items-center px-6 py-3 border border-transparent shadow-sm text-base font-medium rounded-md text-white cobalt-button-color hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >Next</button>
    </div>
    <div id="covModal" class="hidden">
      <div
        tabindex="0"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full w-3/5">
          <div class="bg-white px-4 mt-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
            <div
              class="flex flex-row justify-between p-2 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800">Coverage Details</p>
              <i class="fa fa-close w-6 h-6 cursor-pointer" @click="openCovDetail(false)"></i>
            </div>
            <div class="flex flex-col px-6 py-5 bg-gray-50 fee-popup-scroll">
              <!-- <img
                class="block w-auto"
                src="@/assets/Images/attorney_type.png"
                alt="U.S.Legal"
              />-->
              <p class="mt-1 text-md text-gray-500">
                You have indicated to accept matters (FAM) that will be paid out in accordance with the corresponding U.S. Legal Services Inc. Attorney Fee Schedule, and also referrals (REF) of U. S. Legal plan members to provide a free consultation and bill the member directly at a discounted rate.
                Please indicate if you provide support for both or one by selecting the appropriate checkboxs next to the coverages.
              </p>
            </div>
            <button
              @click="openCovDetail(false)"
              type="button"
              class="relative cursor-pointer inline-flex px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2"
            >Close</button>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
    <div id="saveExitModal" class="hidden">
      <div
        tabindex="0"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-2/4 md:w-full">
          <div class="bg-white px-4 mt-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
            <div
              class="flex flex-row justify-between p-2 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800">
                <i class="fa fa-info-circle" aria-hidden="true"></i> Save and Exit
              </p>
              <i class="fa fa-close w-6 h-6 cursor-pointer" @click="openSaveExitModal(false)"></i>
            </div>
            <div class="flex flex-col px-6 py-5 bg-gray-50 fee-popup-scroll">
              <ul class="px-2 py-2">
                <li>Your Network Attorney Application is partially complete and your data will be saved. To complete the application at another time, return to this link and click 'Join Our Network'. You will enter your email address and your partially complete application will be retrieved.</li>
                <li
                  class="my-2"
                >To save and exit the Network Attorney Application, click the Save & Exit button.</li>
                <li
                  class="my-2"
                >To return back to your application and finish it now, click the Return to Application button.</li>
              </ul>
              <div class="bg-gray-50 sm:flex sm:flex-row-reverse">
                <button
                  @click="saveAttorneyData()"
                  type="button"
                  class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-base font-medium rounded-md text-white cobalt-button-color hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >Save and Exit</button>
                <button
                  @click="openSaveExitModal(false)"
                  type="button"
                  class="mt-3 w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 text-base font-medium sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm text-white bg-gray-400 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                >Return to Application</button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
    <div id="welcomeModal" class="hidden">
      <div
        tabindex="0"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-2/6 md:w-full">
          <div class="bg-white px-4 mt-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
            <div
              class="flex flex-row justify-between p-2 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800">
                <i class="fa fa-info-circle" aria-hidden="true"></i> Welcome Back!
              </p>
              <i class="fa fa-close w-6 h-6 cursor-pointer" @click="openWelcomeModal(false)"></i>
            </div>
            <div class="flex flex-col px-6 py-5 bg-gray-50 fee-popup-scroll">
              <p class="px-2 py-2">
                Welcome back to your Network Attorney Application. Your partially completed application has been retrieved. Please review your information and continue completing your application.
              </p>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import AppPractice from "./AppPractice.vue";
import AppDisclosure from "./AppDisclosure.vue";
import AppPreview from "./AppPreview.vue";
import AppPrimary from "./AppPrimary.vue";
import AppCoverages from "./AppCoverages.vue";
import { mapState } from "vuex";
import Constants from "../../constants.ts"; 
import $ from "jquery";
export default {
  name: "Application",
  data: function() {
    return {
      currentTab: 0,
      isShow: false,
      API_BASE: Constants.API_BASE,
      form: {
        stateCount: { CA: 0, Others: 0 },
        lead: {},
        language_fluent: [],
        attorney_type: [],
        practice_county_list: [],
        coveragelist: [],
        remote_consulting: [],
        referral_cont_fee: false,
        credentials: [],
        addresses: [],
        contacts: []
      }
    };
  },
  mounted() {
    this.isShow = true;
    this.showTab(this.currentTab);
  },
  computed: mapState(["att_user", "tempAttData","leadData"]),
  created() {
    if (this.att_user?.data && this.att_user != undefined) {
      //After attorney login and registered passowrd, Edit Application
      if (
        this.att_user.data.password == null ||
        this.att_user.data.password == ""
      ) {
        this.$toast.success("Please login first to edit details");
        this.$router.push("/login");
      }
    } else {
     
      // If attorney comes first time to submit application after lead signin
        this.form.credentials.push({
          lic_state: "",
          bar_number: "",
          insurance_company: "",
          policy_number: "",
          lic_issue_date: "",
          lic_exp_date: "",
          lic_app_date: "",
          lic_app_exp_date: ""
        });
        this.form.addresses.push({
          type: { id: 0, name: "PRIMARY" },
          index: "address_" + Math.random(),
          address1: "",
          address2: "",
          city: "",
          state: "",
          country: "",
          county: "",
          zip: ""
        });
        this.form.contacts.push({
          name: "",
          type: { id: 0, name: "PRIMARY" },
          email: "",
          phone: "",
          cell: "",
          fax: "",
          ext: ""
        });
        if (this.tempAttData.is_attorney_exist) {
          let keys = Object.keys(this.tempAttData);
          keys.forEach(key => {
            this.form[key] = this.tempAttData[key];
          });
          
          setTimeout(() => {
            const lastRouteName = localStorage.getItem("LS_ROUTE_KEY");
            if(lastRouteName=="sign-in"){
              this.openWelcomeModal(true);
            }
          }, 500);
        }
    }

    //If get any error from API
    this.$store.watch(
      () => this.$store.state.errors,
      value => {
        if (value.length > 0) {
          this.$toast.error("Something went wrong, Please try again!");
          $("#nextBtn").prop('disabled', false);
        }
      }
    );
    //If application submitted success from API
    this.$store.watch(
      () => this.$store.state.attorney_data,
      value => {
        if (value != null && value != undefined) {
          if (value.id != null) {
            this.$router.push("/signing");
          }
        }
      }
    );
  },
  components: {
    AppPractice,
    AppPrimary,
    AppPreview,
    AppDisclosure,
    AppCoverages
  },
  methods: {
    fixStepIndicator: function(n) {
      //active tab logic
      var i,
        x = document.getElementsByClassName("step-wizard");
      for (i = 0; i < x.length; i++) {
        x[i].className = x[i].className.replace(" active", "");
      }
      x[n].className += " active";
    },
    // Logic of move prev next tab and other UI toggles and also after some tab, calling some methods from store to get data
    nextPrev: function(n) {
      $("html, body").animate({ scrollTop: 0 }, 1000);
      //validation start
      if (n != -1) {
        var cmp = "child_comp_" + this.currentTab;
        this.$refs[cmp].submitApplication();
        if (
          this.$refs[cmp].v$.form.$pending ||
          this.$refs[cmp].v$.form.$error
        ) {
          this.$toast.error("please fill required fields!");
          return;
        }
        if(this.form.practice_county_list.length>0){
        let check_cdl_rate=true;
        this.form.practice_county_list.forEach(element => {
          if(element.plan_class=='CDL' && (element.cdl_rate==0 || element.cdl_rate=="") && element.deleted==0){
            check_cdl_rate=false;
          }
        });
        if(!check_cdl_rate){
          this.$toast.error("Please add CDL rate for CDL Plan");
          return false;
        }
      }
      }
      //validation end
      var x = document.getElementsByClassName("tab-wizard");
      if (
        document.getElementById("nextBtn").innerHTML !=
        "Proceed to Signature Page"
      ) {
        x[this.currentTab].style.display = "none";
        if (n != -1) {
          document
            .getElementsByClassName("border-gray-300")[this.currentTab].classList.add("cobalt-border-color");
          document
            .getElementsByClassName("text-gray-300")[this.currentTab].removeAttribute("fill");
          if (this.currentTab == 1) {
            this.$store.dispatch("getCoverages", this.form.attorney_type);
            this.form.credentials.forEach(element => {
              if (element.lic_state["STATECD"] == "CA") {
                this.form.stateCount["CA"] = this.form.stateCount["CA"] + 1;
              } else {
                this.form.stateCount["Others"] =
                  this.form.stateCount["Others"] + 1;
              }
            });
            if (
              this.form["other_languages"] != null &&
              this.form["other_languages"] != undefined
            ) {
              var str_array = this.form["other_languages"].split(",");
              str_array.forEach(element => {
                this.form["language_fluent"].push(element.replace(/\s+/g, ""));
              });
            }
            var newLang = [{ lang: {} }];
            if (this.form["language_fluent"].length > 0) {
              let i = 0;
              this.form["language_fluent"].forEach(element => {
                if (element != "Others") {
                  newLang[0]["lang"][i] = element.replace(/\s+/g, "");
                  i++;
                }
              });
            }
            this.form["lang_spoken"] = JSON.stringify(newLang[0]);
            if (
              this.form.attorney_type.includes("FAM") &&
              this.form.attorney_type.includes("REF")
            ) {
              this.openCovDetail(true);
            }
          } else if (this.currentTab == 2) {
            if (
              this.form.referral_cont_fee != null ||
              this.form.referral_cont_fee != ""
            ) {
              if (this.form.referral_cont_fee == true) {
                this.form.attr_tags = JSON.stringify([
                  { text: "Referral-Contingency-Fee" }
                ]);
                console.log(this.form.attr_tags);
              }
            }
          }
        } else {
          document
            .getElementsByClassName("border-gray-300")[this.currentTab - 1].classList.remove("cobalt-border-color");
          document
            .getElementsByClassName("text-gray-300")[this.currentTab - 1].setAttribute("fill", "none");
        }

        this.currentTab = this.currentTab + n;
        this.showTab(this.currentTab);
      } else {
        if (n == 1) {
          if (this.form.attorney_type.includes("FAM")) {
            if (!this.form.review_agreements) {
              this.$toast.error("please accept the agreement!");
              return;
            }
          }
          var attorney_type = [];
          $.each(this.form.attorney_type, function(i, el) {
            if ($.inArray(el, attorney_type) === -1) attorney_type.push(el);
          });
          this.form.attorney_type = attorney_type;
          this.$store.dispatch("storAttorneyData", {
            data: this.form
          });
          $("#nextBtn").prop('disabled', true);
        } else {
          if (n != -1) {
            document
              .getElementsByClassName("border-gray-300")[this.currentTab].classList.add("cobalt-border-color");
            document
              .getElementsByClassName("text-gray-300")[this.currentTab].removeAttribute("fill");
          } else {
            x[this.currentTab].style.display = "none";
            document
              .getElementsByClassName("border-gray-300")[this.currentTab - 1].classList.remove("cobalt-border-color");
            document
              .getElementsByClassName("text-gray-300")[this.currentTab - 1].setAttribute("fill", "none");
          }
          this.currentTab = this.currentTab + n;
          this.showTab(this.currentTab);
        }
      }
    },
    openCovDetail: function(value) {
      if (value) {
        document.getElementById("covModal").removeAttribute("class");
      } else {
        document.getElementById("covModal").setAttribute("class", "hidden");
      }
    },
    openWelcomeModal: function(value) {
      if (value) {
        document.getElementById("welcomeModal").removeAttribute("class");
      } else {
        document.getElementById("welcomeModal").setAttribute("class", "hidden");
      }
    },
    downloadAppPdf: function() {
      console.log(this.form);
       this.$store
        .dispatch("downloadAppPdf", this.form)
        .then(result => {
          if (result.status == 'success') {
            window.open(this.API_BASE +
                        'downloadAggreementFiles.php?name='+result.file_name+'&folder=enrollment_sign_pdfs');
          }
        })
        .catch(error => {
          this.$toast.error("Something went wrong, please try again!");
          console.log("error: ", error);
        });
    },
    openSaveExitModal: function(value) {
      if (value) {
        document.getElementById("saveExitModal").removeAttribute("class");
      } else {
        document
          .getElementById("saveExitModal")
          .setAttribute("class", "hidden");
      }
    },
    saveAttorneyData: function() {
      console.log(this.form);
      this.$store
        .dispatch("saveAttorneyTempData", this.form)
        .then(result => {
          if (result.data.status == "success") {
            this.$toast.success(result.data.message);
            this.openSaveExitModal(false);
          }
        })
        .catch(error => {
          this.$toast.error("Something went wrong, please try again!");
          console.log("error: ", error);
        });
    },
    showTab: function(n) {
      var x = document.getElementsByClassName("tab-wizard");
      x[n].style.display = "block";
      if (n == 0) {
        document.getElementById("prevBtn").style.display = "none";
        document.getElementById("save_temp").classList.add("md:col-span-7");
      } else {
        document.getElementById("prevBtn").style.display = "inline";
        document.getElementById("save_temp").classList.remove("md:col-span-7");
      }
      if (n == x.length - 1) {
        document.getElementById("save_temp").classList.remove("md:col-span-6");
        document.getElementById("save_temp").classList.add("md:col-span-1");
         document.getElementById("download_app_pdf").style.display = "inline";
        document.getElementById("nextBtn").innerHTML =
          "Proceed to Signature Page";
      } else {
        document.getElementById("save_temp").classList.remove("md:col-span-1");
        document.getElementById("save_temp").classList.add("md:col-span-6");
        document.getElementById("download_app_pdf").style.display = "none";
        document.getElementById("nextBtn").innerHTML = "Next";
      }
      this.fixStepIndicator(n);
    }
  }
};
</script>
